export default __webpack_public_path__ + "53b8b5569f03ddbd8cd04a1d478eaa49.png";